import HtmlHead from './HtmlHead'

export default HtmlHead